import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#6993FF',
                secondary: '#36cdc5',
                accent: '#8c9eff',
                error: '#f64e60',
            },
            dark: {
                primary: '#6993FF',
                secondary: '#36cdc5',
                accent: '#8c9eff',
                error: '#f64e60',
            },
        },
    },

});
